module.exports = __webpack_public_path__ + "img/Mail_black.f984e3aa.svg";